import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
// Merge sub-app utility classes (chandan-sidebar, data-table, ai-prose, kpi-card, etc.)
// into the global stylesheet so components across all merged modules render
// consistently with the shared Voltline theme.
import "@partners/index.css";
import "@formulations/index.css";
import "@dossiers/index.css";
import App from "@/App";
import "@/styles/voltline.css";
import "@/styles/forms.css";
import "@/styles/workspace.css";
import "@/styles/usability.css";
document.documentElement.dataset.theme = "voltline";
document.documentElement.dataset.layout = "lexa";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
